module.exports = __webpack_public_path__ + "media/images/background-796eb406a6fe67a938e112b67031fca6.png";